import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import Navbar from '@/components/landing/Navbar';
import Footer from '@/components/landing/Footer';
import { ArrowLeft } from 'lucide-react';
import { useLanguage } from '@/context/LanguageContext';

const TermsPage = () => {
  const { language } = useLanguage();

  return (
    <div className="min-h-screen bg-white" data-testid="terms-page">
      <Navbar />
      
      <main className="vf-section">
        <div className="vf-container">
          <Link 
            to="/" 
            className="inline-flex items-center gap-2 text-slate-600 hover:text-[#1e3a5f] mb-8"
          >
            <ArrowLeft className="w-4 h-4" />
            {language === 'es' ? 'Volver' : 'Back'}
          </Link>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="max-w-3xl mx-auto"
          >
            <h1 className="vf-heading-1 text-[#1e3a5f] mb-8">
              {language === 'es' ? 'Términos y Condiciones' : 'Terms & Conditions'}
            </h1>

            <div className="prose prose-slate max-w-none">
              <p className="text-slate-600 mb-8">
                {language === 'es' 
                  ? 'Última actualización: Enero 2025'
                  : 'Last updated: January 2025'}
              </p>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-[#1e3a5f] mb-4">
                  1. {language === 'es' ? 'Aceptación de los Términos' : 'Acceptance of Terms'}
                </h2>
                <p className="text-slate-600">
                  {language === 'es'
                    ? 'Al acceder y utilizar VendFactura, aceptas estar sujeto a estos términos y condiciones. Si no estás de acuerdo con alguna parte de estos términos, no podrás acceder al servicio.'
                    : 'By accessing and using VendFactura, you agree to be bound by these terms and conditions. If you do not agree with any part of these terms, you may not access the service.'}
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-[#1e3a5f] mb-4">
                  2. {language === 'es' ? 'Descripción del Servicio' : 'Service Description'}
                </h2>
                <p className="text-slate-600">
                  {language === 'es'
                    ? 'VendFactura proporciona software de punto de venta (TPV) y facturación conforme a la normativa VeriFactu de España. El servicio incluye gestión de inventario, facturación electrónica, informes y otras funcionalidades según el plan contratado.'
                    : 'VendFactura provides point of sale (POS) software and invoicing compliant with Spain\'s VeriFactu regulations. The service includes inventory management, electronic invoicing, reports and other features depending on the contracted plan.'}
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-[#1e3a5f] mb-4">
                  3. {language === 'es' ? 'Cuentas de Usuario' : 'User Accounts'}
                </h2>
                <p className="text-slate-600">
                  {language === 'es'
                    ? 'Para utilizar VendFactura, debes crear una cuenta proporcionando información precisa y completa. Eres responsable de mantener la confidencialidad de tu cuenta y contraseña.'
                    : 'To use VendFactura, you must create an account providing accurate and complete information. You are responsible for maintaining the confidentiality of your account and password.'}
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-[#1e3a5f] mb-4">
                  4. {language === 'es' ? 'Facturación y Pagos' : 'Billing and Payments'}
                </h2>
                <p className="text-slate-600">
                  {language === 'es'
                    ? 'Las suscripciones se facturan mensualmente. Puedes cancelar tu suscripción en cualquier momento. No se realizan reembolsos por períodos parciales.'
                    : 'Subscriptions are billed monthly. You can cancel your subscription at any time. No refunds are provided for partial periods.'}
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-[#1e3a5f] mb-4">
                  5. {language === 'es' ? 'Cumplimiento Fiscal' : 'Tax Compliance'}
                </h2>
                <p className="text-slate-600">
                  {language === 'es'
                    ? 'VendFactura proporciona herramientas para facilitar el cumplimiento de la normativa VeriFactu. Sin embargo, la responsabilidad final del cumplimiento fiscal recae en el usuario. Recomendamos consultar con un asesor fiscal.'
                    : 'VendFactura provides tools to facilitate VeriFactu compliance. However, the ultimate responsibility for tax compliance lies with the user. We recommend consulting with a tax advisor.'}
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-[#1e3a5f] mb-4">
                  6. {language === 'es' ? 'Contacto' : 'Contact'}
                </h2>
                <p className="text-slate-600">
                  {language === 'es'
                    ? 'Para cualquier consulta sobre estos términos, contacta con nosotros en legal@vendfactura.com'
                    : 'For any questions about these terms, contact us at legal@vendfactura.com'}
                </p>
              </section>
            </div>
          </motion.div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default TermsPage;
